// src/pages/About.jsx
import React from "react";
import heroImg from "../assets/machine.png";
import ceoImg from "../assets/SanjayMore.png"; 
import { Helmet } from "react-helmet-async";

const certificationsPoints = [
  "ISO 9001: Quality management certification ensuring consistent processes.",
  "ASNT Level III: Advanced certified NDT inspectors with supervisory capability.",
  "ASNT Level II: Certified NDT inspectors for UT, MT, PT.",
  "PCN Level II: Certified personnel for Phased Array Ultrasonic Testing (PAUT) and Ultrasonic Testing (UT).",
  "API 570: Piping inspection certification ensuring industry-standard compliance.",
  "AWS Certified: Welding inspection and quality assurance certification.",
];

// Note: employeeCertifications was unused, removed for cleaner code.eeee

const About = () => {
  return (
    <>

      <Helmet>

        <title>
          About Focus Inspection Technology | NDT Inspection Company | PAUT TOFD UT RT MT PT
        </title>

        <meta
          name="description"
          content="
About Focus Inspection Technology, a professional Non Destructive Testing company providing PAUT, TOFD, UT, RT, MT, PT, welding inspection, pipeline inspection and industrial inspection services worldwide. Focus Inspection Technology is also known as Focus Inspection and Focus NDT.
"
        />

        <meta
          name="keywords"
          content="
Focus Inspection Technology,
About Focus Inspection,
Focus NDT,
NDT company India,
inspection company,
PAUT TOFD company,
industrial inspection,
welding inspection,
pipeline inspection,
refinery inspection,
ndt services
"
        />

        <link
          rel="canonical"
          href="https://focusinspectiontechnology.com/about"
        />

        {/* Open Graph */}

        <meta
          property="og:title"
          content="About Focus Inspection Technology | NDT Inspection Company"
        />

        <meta
          property="og:description"
          content="Learn about Focus Inspection Technology, industrial NDT inspection company providing advanced testing services worldwide."
        />

        <meta
          property="og:image"
          content="https://focusinspectiontechnology.com/images/Team.jpeg"
        />

        <meta
          property="og:url"
          content="https://focusinspectiontechnology.com/about"
        />

        <meta property="og:type" content="website" />

        {/* Twitter */}

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="About Focus Inspection Technology"
        />

        <meta
          name="twitter:description"
          content="Professional NDT inspection company providing PAUT TOFD UT RT MT PT worldwide."
        />

        <meta
          name="twitter:image"
          content="https://focusinspectiontechnology.com/images/Team.jpeg"
        />

      </Helmet>

      <div className="w-full bg-gray-50">
        {/* ===== HERO SECTION ===== */}
        <section className="relative w-full h-80 flex items-center justify-center mb-16 overflow-hidden">
          {/* Gradient Background */}
          <div className="absolute inset-0 bg-gradient-to-r from-gray-800 to-blue-900"></div>

          {/* Industrial Pattern Overlay */}
          <svg
            className="absolute inset-0 w-full h-full opacity-20 animate-pulse"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Hex grid pattern */}
            <defs>
              <pattern
                id="hexPattern"
                width="60"
                height="52"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(30)"
              >
                <polygon
                  points="30,0 60,15 60,45 30,60 0,45 0,15"
                  stroke="white"
                  strokeWidth="0.3"
                  fill="none"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#hexPattern)" />

            {/* Diagonal lines */}
            <line x1="0" y1="0" x2="800" y2="800" stroke="white" strokeWidth="0.2" />
            <line x1="800" y1="0" x2="0" y2="800" stroke="white" strokeWidth="0.2" />

            {/* Gear-like circles */}
            <circle cx="100" cy="100" r="80" stroke="white" strokeWidth="0.5" fill="none" />
            <circle cx="600" cy="50" r="120" stroke="white" strokeWidth="0.5" fill="none" />
          </svg>

          {/* Hero Text */}
          <h1 className="relative text-4xl md:text-5xl font-extrabold text-center px-4 text-white drop-shadow-lg bg-clip-text text-transparent bg-gradient-to-r from-gray-300 via-white to-gray-400">
            About FOCUS Inspection Technology
          </h1>
        </section>

        {/* Split Content Section & New Full-Width CEO Card */}
        <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-20">
          
          {/* Top Two-Column Layout */}
          <div className="flex flex-col lg:flex-row gap-12 mb-16">
            {/* Left Column: Our Company - TEXT CLEANED */}
            <div className="lg:w-1/2 space-y-6">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-l-4 border-blue-600 pl-4">
                Our Company
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                FOCUS Inspection Technology is an independent NDT company providing Non-Destructive Testing (NDT) services for industries worldwide. We specialize in advanced NDT inspection and certification services, including manpower services.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                Our expertise includes Phased Array Ultrasonic Testing (PAUT), Time of Flight Diffraction (TOFD), Ultrasonic Testing (UT), and Magnetic Particle Testing (MT) for offshore and onshore pipelines and engineering fabrications. We operate with Olympus OmniScan MX2 32:128PR and MX2 16:64 models, along with in-house designed motorized/manual PAUT and TOFD scanners for field durability.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                FOCUS Inspection Technology is focused on delivering unparalleled expertise, reliability of equipment, quality personnel, and prompt response to client needs. We also conduct NDT training courses and examinations to qualify candidates as ASNT Level II inspectors.
              </p>
            </div>

            {/* Right Column: Key Certifications (Only) */}
            <div className="lg:w-1/2 space-y-12">
              
              {/* ===== Key Certifications ===== */}
              <div className="bg-white p-6 rounded-2xl shadow-lg border-l-4 border-blue-600">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                  Key Certifications
                </h3>
                <ul className="space-y-3">
                  {certificationsPoints.map((point, idx) => (
                    <li
                      key={idx}
                      className="relative pl-6 text-gray-700 text-lg leading-relaxed before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:h-3 before:w-3 before:rounded-full before:bg-blue-600"
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
              
            </div>
          </div>
          
          {/* ===== CEO PROFILE CARD (RESPONSIVENESS AND TEXT CLEANED) ===== */}
          <div className="w-full py-16 bg-gradient-to-br from-gray-50 via-white to-blue-50">
            <div className="max-w-6xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-2xl border-t-8 border-blue-700 relative overflow-hidden">

              {/* Decorative Accent (Soft Corner Gradient) */}
              <div className="absolute top-0 right-0 w-56 h-56 bg-blue-100 rounded-bl-full opacity-30 blur-2xl"></div>

              {/* Heading */}
              <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-12 text-center tracking-tight">
                Meet Our Founder & CEO
              </h2>

              {/* Flex Layout - The core responsive element */}
              <div className="flex flex-col md:flex-row items-center md:items-start gap-10 relative z-10">

                {/* Image Section */}
                <div className="w-full md:w-5/12 flex justify-center md:justify-start">
                  <div className="relative group w-full max-w-xs sm:max-w-sm">
                    <img
                      src={ceoImg}
                      alt="Sanjay More, Founder & CEO"
                      className="w-full h-auto max-h-96 object-cover rounded-xl shadow-2xl border border-gray-200 group-hover:scale-[1.02] transition-transform duration-500 ease-in-out"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/400x480';
                      }}
                    />
                    {/* Soft blue glow */}
                    <div className="absolute inset-0 rounded-xl bg-blue-600 opacity-0 group-hover:opacity-10 transition duration-500"></div>
                  </div>
                </div>

                {/* Content Section - Added text-center, md:text-left for full responsiveness */}
                <div className="w-full md:w-7/12 space-y-6 text-center md:text-left"> 
                  <div>
                    <h3 className="text-4xl font-extrabold text-gray-900 leading-tight">
                      Sanjay More
                    </h3>
                    {/* Inline-block helps centering the bordered text on mobile */}
                    <p className="text-lg text-blue-800 font-semibold uppercase tracking-wide border-b-2 border-blue-100 pb-2 inline-block">
                      Founder & CEO, Focus Inspection Technology
                    </p>
                  </div>

                  <p className="text-gray-700 text-lg leading-relaxed">
                    With over 20 years of practical experience in 
                    <strong> Non-Destructive Testing (NDT)</strong>, 
                    <strong> Mr. Sanjay More</strong> has played a key role in improving inspection quality and safety across many industries. 
                    His leadership brings together strong technical knowledge and modern innovation — creating a work culture focused on accuracy, trust, and continuous growth.
                  </p>


                  <blockquote className="p-6 bg-blue-50 border-l-8 border-blue-700 rounded-xl shadow-inner">
                    <p className="text-gray-900 text-xl italic leading-relaxed font-medium">
                      "Our mission is to combine the highest standards of NDT inspection quality with continuous technological innovation — ensuring absolute safety, integrity, and client satisfaction."
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
          {/* END CEO CARD */}

        </section>
      </div>
    </>
  );
};

export default About;